function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlaybooksActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-playbooks-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.23,0h-.66C13.39,0,10.7,1,9.41,2.6,7.92.82,4.57-.33.73.08h0A.82.82,0,0,0,0,.9V14.36a.82.82,0,0,0,.82.82H.89a7.09,7.09,0,0,1,1,0c3.27,0,5.58,1.23,6.17,2.41H8a.82.82,0,0,0,.73.45h.51a.82.82,0,0,0,.73-.45h0c.6-1.19,2.91-2.41,6.17-2.41a7.87,7.87,0,0,1,1,0h0a.82.82,0,0,0,.88-.75s0,0,0-.07V.82A.82.82,0,0,0,17.23,0ZM6.55,12.9V5.1L13,9Z",
    style: {
      fill: "#3fa9f5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaybooksActive);
export default __webpack_public_path__ + "static/media/icon-playbooks-active.4b739b33ae6f0f7562801fb41fc14ca8.svg";
export { ForwardRef as ReactComponent };